export enum PptxReadOption {
    SlidesOnly = 0,
    SlidesAndNotes = 1,
}
